/* eslint-disable prefer-destructuring */
/**
 * Carousel setup
 */

import Swiper, { Navigation, Pagination, Autoplay, Keyboard } from 'swiper';
import 'swiper/swiper.min.css';

Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);

const carousels = document.querySelectorAll('.js-carousel');
if (carousels) {
	carousels.forEach((wrapper) => {
		// determine setup
		const carousel = wrapper.querySelector('.carousel__frame');
		const slidesPerView = parseInt(carousel.dataset.slidesPerView);
		const autoplay = parseInt(carousel.dataset.autoplay);
		const loop = carousel.dataset.loop === '1';
		const opt = {
			loop,
			speed: 300,
			slidesPerView: 1,
			spaceBetween: slidesPerView > 1 ? 16 : 0,
			initialSlide: slidesPerView > 1 ? 1 : 0,
			// centeredSlides: true,
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				600: {
					slidesPerView: slidesPerView > 1 ? 2 : 1,
				},
				960: {
					slidesPerView,
					spaceBetween: slidesPerView > 1 ? 22 : 0,
				},
			},
			// show/hide via css (complex request by client...)
			navigation: {
				nextEl: wrapper.querySelector('.swiper-button-next'),
				prevEl: wrapper.querySelector('.swiper-button-prev'),
			},
			// show/hide via css (complex request by client...)
			pagination: {
				el: wrapper.querySelector('.swiper-pagination'),
				type: 'bullets',
				bulletElement: 'button',
				clickable: true,
				bulletClass:
					'swiper-pagination-bullet button--plus button--basic',
			},
			on: {
				afterInit(swiper) {
					// add accessibility to pagination
					swiper.pagination.bullets.forEach((bullet, i) =>
						bullet.setAttribute('aria-label', `Slide ${i + 1}`)
					);
				},
				touchStart(swiper) {
					const slide = swiper.slides[swiper.activeIndex];
					// if we're playing a vr then allow scroll within it
					if (slide.querySelector('.media__vr')) {
						if (
							!slide.querySelector(
								'img[src$="garden-gnome-package/include/play.png"]'
							)
						) {
							swiper.allowTouchMove = false;
						}
					} else {
						swiper.allowTouchMove = true;
					}
				},
			},
		};

		if (autoplay) {
			opt.autoplay = {
				delay: autoplay * 1000,
				disableOnInteraction: true,
			};
		}

		// eslint-disable-next-line no-new
		new Swiper(carousel, opt);
	});
}
